export default __webpack_public_path__ + "static/media/home-work.e62ebc65.svg";